import {
  GET_DISCOUNT_REASONS,
  GET_DISCOUNT_REASONS_COMPLETED,
  GET_DISCOUNT_REASONS_FAILED,
  GET_DISCOUNT_REASON,
  GET_DISCOUNT_REASON_COMPLETED,
  GET_DISCOUNT_REASON_FAILED,
  ADD_DISCOUNT_REASON,
  ADD_DISCOUNT_REASON_COMPLETED,
  ADD_DISCOUNT_REASON_FAILED,
  SEARCH_DISCOUNT_REASONS,
  SEARCH_DISCOUNT_REASONS_COMPLETED,
  SEARCH_DISCOUNT_REASONS_FAILED,
  UPDATE_DISCOUNT_REASON_VISIBILITY,
  UPDATE_DISCOUNT_REASON_VISIBILITY_COMPLETED,
  UPDATE_DISCOUNT_REASON_VISIBILITY_FAILED,
  UPDATE_DISCOUNT_REASON,
  UPDATE_DISCOUNT_REASON_COMPLETED,
  UPDATE_DISCOUNT_REASON_FAILED,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  discountReasons: [],
  discountReasonsLoading: false,
  discountReasonsError: null,
  discountReason: null,
  discountReasonLoading: false,
  discountReasonError: null,
  addingDiscountReason: false,
  updatingDiscountReason: false,
  updatingDiscountReasonVisibility: false,
  updateDiscountReasonVisibilityError: null,
  // deleteDiscountReasonModalVisible: false,
  // discountReasonToDelete: null,
  // discountReasonDeleting: false,
  search: searchDefault,
};

const discountReasonReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_DISCOUNT_REASONS:
      return handleSearch(state, 'search', action.payload);
    case SEARCH_DISCOUNT_REASONS_COMPLETED:
      return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_DISCOUNT_REASONS_FAILED:
      return handleSearchFailed(state, 'search', action.payload);
    case GET_DISCOUNT_REASONS: {
      return {
        ...state,
        discountReasonsLoading: true,
        discountReasons: [],
        discountReasonsError: null,
      };
    }
    case GET_DISCOUNT_REASONS_COMPLETED: {
      return {
        ...state,
        discountReasonsLoading: false,
        discountReasons: action.payload.data,
      };
    }
    case GET_DISCOUNT_REASONS_FAILED: {
      return {
        ...state,
        discountReasonsLoading: false,
        discountReasonsError: action.payload,
      };
    }
    case GET_DISCOUNT_REASON: {
      return {
        ...state,
        discountReasonLoading: true,
        discountReason: null,
        discountReasonError: null,
      };
    }
    case GET_DISCOUNT_REASON_COMPLETED: {
      return {
        ...state,
        discountReasonLoading: false,
        discountReason: action.payload,
      };
    }
    case GET_DISCOUNT_REASON_FAILED: {
      return {
        ...state,
        discountReasonLoading: false,
        discountReasonError: action.payload,
      };
    }
    case ADD_DISCOUNT_REASON: {
      return {
        ...state,
        addingDiscountReason: true,
      };
    }
    case ADD_DISCOUNT_REASON_COMPLETED: {
      return {
        ...state,
        addingDiscountReason: false,
      };
    }
    case ADD_DISCOUNT_REASON_FAILED: {
      return {
        ...state,
        addingDiscountReason: false,
      };
    }
    case UPDATE_DISCOUNT_REASON: {
      return {
        ...state,
        updatingDiscountReason: true,
      };
    }
    case UPDATE_DISCOUNT_REASON_COMPLETED: {
      return {
        ...state,
        updatingDiscountReason: false,
      };
    }
    case UPDATE_DISCOUNT_REASON_FAILED: {
      return {
        ...state,
        updatingDiscountReason: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    case UPDATE_DISCOUNT_REASON_VISIBILITY: {
      return {
        ...state,
        updatingDiscountReasonVisibility: true,
        updateDiscountReasonVisibilityError: null,
      };
    }
    case UPDATE_DISCOUNT_REASON_VISIBILITY_COMPLETED: {
      return {
        ...state,
        updatingDiscountReasonVisibility: false,
      };
    }
    case UPDATE_DISCOUNT_REASON_VISIBILITY_FAILED: {
      return {
        ...state,
        updatingDiscountReasonVisibility: false,
        updateDiscountReasonVisibilityError: action.payload,
      };
    }
    // case SHOW_DELETE_DISCOUNT_REASON_MODAL: {
    //   return {
    //     ...state,
    //     deleteDiscountReasonModalVisible: true,
    //     discountReasonToDelete: action.payload,
    //   };
    // }
    // case HIDE_DELETE_DISCOUNT_REASON_MODAL: {
    //   return {
    //     ...state,
    //     deleteDiscountReasonModalVisible: false,
    //     discountReasonToDelete: null,
    //   };
    // }
    // case DELETE_DISCOUNT_REASON: {
    //   return {
    //     ...state,
    //     discountReasonDeleting: true,
    //   };
    // }
    // case DELETE_DISCOUNT_REASON_COMPLETED: {
    //   return {
    //     ...state,
    //     discountReasonDeleting: false,
    //   };
    // }
    // case DELETE_DISCOUNT_REASON_FAILED: {
    //   return {
    //     ...state,
    //     discountReasonDeleting: false,
    //   };
    // }
    default:
      return state;
  }
};

export default discountReasonReducer;



// WEBPACK FOOTER //
// ./src/DiscountReason/reducer.js